import Commander from "./Commander";
import * as PIXI from "pixi.js-legacy";
import {pixiSetTimeout} from "../framework/src/engine/pixi/pixiTimeout";
import {getSprite} from "../framework/src/modules/Sprite";

class WinLines {
    constructor(commander) {
        this.commander = commander;

        this.layerLines = this.commander.layers.winLines;
        this.layerNumbers = this.commander.layers.winLineNumbers;

        this.winLines = [];

        this.mouseLock = [false, false, false, false, false, false, false, false, false, false];
        this.idleLock = [false, false, false, false, false, false, false, false, false, false];
    }

    init() {
        WinLines.createLines(this.layerLines ,this.winLines);
        this.leftCircles = this.createLeftCircles(this.layerNumbers);
        this.rightCircles = this.createRightCircles(this.layerNumbers);
        this.createEventListeners();
    }

    static createLines(layer, array) {
        for (let lineNumber = 1; lineNumber <11; lineNumber++) {
            let winLine;
            let y = [ 400, 200, 600, 390, 390, 305, 495, 500, 300, 300];
            switch (lineNumber) {
                case 1:
                case 2:
                case 3:
                    winLine = getSprite("winline_1-3.png", 640,y[lineNumber-1]);
                    break;
                case 4:
                case 5:
                    winLine = getSprite("winline_4-5.png", 640,y[lineNumber-1]);
                    if(lineNumber === 5)
                        winLine.scale.y = -1;
                    break;
                case 6:
                case 7:
                    winLine = getSprite("winline_6-7.png", 640,y[lineNumber-1]);
                    if(lineNumber === 7)
                        winLine.scale.y = -1;
                    break;
                case 8:
                case 9:
                    winLine = getSprite("winline_8-9.png", 640,y[lineNumber-1]);
                    if(lineNumber === 8)
                        winLine.scale.y = -1;
                    break;
                case 10:
                    winLine = getSprite("winline_10.png", 640,y[lineNumber-1]);
                    break;
            }
            winLine.visible = false;
            layer.addChild(winLine);
            array.push(winLine);
        }
    }

    // adds the circles on the left side to screen, adds onmouseover listeners
    createLeftCircles(layer) {
        let val = [
            { x : 45, y : 410, val : 1 , shiftY : 23 },
            { x : 60, y : 170, val : 2 , shiftY : 23 },
            { x : 60, y : 590, val : 3 , shiftY : 23 },
            { x : 75, y : 110, val : 4 , shiftY : 23 },
            { x : 75, y : 650, val : 5 , shiftY : 23 },
            { x : 52, y : 230, val : 6 , shiftY : 23 },
            { x : 52, y : 530, val : 7 , shiftY : 23 },
            { x : 48, y : 470, val : 8 , shiftY : 23 },
            { x : 48, y : 290, val : 9 , shiftY : 23 },
            { x : 45, y : 350, val : 10 , shiftY : 23 }
        ];
        let left = new PIXI.Container();
        left.name = "right";
        for (let i = 0; i < val.length; i++) {
            let circle = this.getCircle(val[i].x, val[i].y, val[i].val, 1);
            left.addChild(circle);
        }
        layer.addChild(left);
        return left;
    }

    // adds the circles on the left side to screen, adds onmouseover listeners
    createRightCircles(layer) {
        let val = [
            { x : 1235, y : 410, val : 1 , shiftY : 23 },
            { x : 1220, y : 170, val : 2 , shiftY : 23 },
            { x : 1220, y : 590, val : 3 , shiftY : 23 },
            { x : 1205, y : 110, val : 4 , shiftY : 23 },
            { x : 1205, y : 650, val : 5 , shiftY : 23 },
            { x : 1228, y : 230, val : 6 , shiftY : 23 },
            { x : 1228, y : 530, val : 7 , shiftY : 23 },
            { x : 1232, y : 470, val : 8 , shiftY : 23 },
            { x : 1232, y : 290, val : 9 , shiftY : 23 },
            { x : 1235, y : 350, val : 10 , shiftY : 23 }
        ];
        let right = new PIXI.Container();
        right.name = "right";
        for (let i = 0; i < val.length; i++) {
            let circle = this.getCircle(val[i].x, val[i].y, val[i].val, -1);
            right.addChild(circle);
        }
        layer.addChild(right);
        return right;
    }

    getCircle(x, y, val, scaleX) {
        let circle = new PIXI.Container();
        circle.interactive = true;
        let on = Commander.getSprite("winLines_circle_on.png", x, y);
        on.scale.x = scaleX;
        on.alpha = 0;
        let off = Commander.getSprite("winLines_circle_off.png", x, y);
        off.scale.x = scaleX;
        let numberOff = this.getCircleTextOff(x, y, val);
        let numberOn = this.getCircleTextOn(x, y, val);
        numberOn.alpha = 0;
        circle.addChild(off, on, numberOff, numberOn);
        return circle;
    }

    getCircleTextOff(x, y, val) {
        let number = new PIXI.BitmapText(val.toString(),  this.getNumberStyle());
        number.anchor.set(0.5,0.5);
        number.position.set(x+1, y - 23);
        return number;
    }

    getCircleTextOn(x, y, val) {
        let number = new PIXI.BitmapText(val.toString(), this.getNumberStyle());
        number.anchor.set(0.5,0.5);
        number.position.set(x+1, y - 23);
        return number;
    }

    getNumberStyle() {
        return {
            fontName: "winlines_circle_on-export",
            fontSize: 80,
            tint: 0xFFFFFF,
            align: 'center',
            letterSpacing: 0,
            maxWidth: 1280
        };
    }

    createEventListeners() {
        for (let i = 0; i < 10; i++) {
            this.leftCircles.children[i].mouseover = this.rightCircles.children[i].mouseover = () => {
                this.showWinLine(i);
                this.mouseLock[i] = true;
            };

            this.leftCircles.children[i].mouseout = this.rightCircles.children[i].mouseout = () => {
                this.mouseLock[i] = false;
                this.hideWinLine(i);
            };
        }
    }

    showWinLine(number) {
        this.winLines[number].visible = true;
        this.showCircle(number);
    }

    hideWinLine(number) {
        this.winLines[number].visible = false;
        this.hideCircle(number);
    }

    showCircle(number) {
        let left = this.leftCircles.children[number];
        let right = this.rightCircles.children[number];
        if (!this.mouseLock[number] && !this.idleLock[number]) {
            left.children[1].alpha = left.children[3].alpha = 1;
            right.children[1].alpha = right.children[3].alpha = 1;
        }
    }

    hideCircle(number) {
        let left = this.leftCircles.children[number];
        let right = this.rightCircles.children[number];
        if (!this.mouseLock[number] && !this.idleLock[number]) {
            left.children[1].alpha = left.children[3].alpha = 0;
            right.children[1].alpha = right.children[3].alpha = 0;
        }
    }

    async showCircleTween(number) {
        let left = this.leftCircles.children[number];
        let right = this.rightCircles.children[number];
        let tween = {alpha: 0};
        await Commander.getTweenAsync(tween, {alpha: 1}, 250,()=>{
            if (!this.mouseLock[number] && !this.idleLock[number]) {
                left.children[1].alpha = left.children[3].alpha = tween.alpha;
                right.children[1].alpha = right.children[3].alpha = tween.alpha;
            }
        }, createjs.Ease.quadOut);
    }

    hideCircleTween(number) {
        let left = this.leftCircles.children[number];
        let right = this.rightCircles.children[number];
        let tween = {alpha: 1};
        Commander.getTween(tween, {alpha: 0}, 250,()=>{
            if (!this.mouseLock[number] && !this.idleLock[number]) {
                left.children[1].alpha = left.children[3].alpha = tween.alpha;
                right.children[1].alpha = right.children[3].alpha = tween.alpha;
                }
        }, () =>{}, createjs.Ease.quadOut);
    }

    circleSpinAnimation() {
        let order = [3, 1, 5, 8, 9, 0, 7, 6, 2, 4];
        for (let i in order) {
            pixiSetTimeout(i*.08, async ()=>{
                await this.showCircleTween(order[i]);
                this.hideCircleTween(order[i]);
            });
        }
    }
}
export default WinLines;
